import { Button } from "@/components/ui/button";
import { SignInButton, useAuth } from "@clerk/clerk-react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated")({
  component: Authenticated,
});

function Authenticated() {
  const { isSignedIn } = useAuth();

  return isSignedIn ? <Outlet /> : <Unauthed />;
}

function Unauthed() {
  return (
    <div className="h-full w-full grid place-items-center">
      <Button asChild>
        <SignInButton />
      </Button>
    </div>
  );
}
